import { fetcher } from "helpers/fetcher";

import { TGetAIJobSuggestionReq, TGetAIJobSuggestionRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const getAIJobSuggestion = async (payload?: TGetAIJobSuggestionReq) => {
  return await fetcher<TGetAIJobSuggestionRes, TGetAIJobSuggestionReq["data"]>(
    ENDPOINT.BU.GET_AI_JOB_SUGGESTION,
    {
      data: payload?.data,
      headers: {
        [API_HEADER.VERSION]: ENDPOINT.BU.GET_AI_JOB_SUGGESTION.version,
        [API_HEADER.BU_ID]: payload?.idBu,
      },
    }
  );
};

export const queryGetAIJobSuggestion = async (
  params?: TGetAIJobSuggestionReq
) => {
  return (await getAIJobSuggestion(params)).data;
};

queryGetAIJobSuggestion._key = (
  params?: TGetAIJobSuggestionReq,
  key?: string
) => [ENDPOINT.BU.GET_AI_JOB_SUGGESTION.url, params, key];
